<script>
  import { _ } from "$helpers/i18n.js";
  import { Accordion, DataTable } from "$lib";
  import { globalStore } from "../../store/globalStore.js";

  const isMobile = globalStore.isMobile;

  let activeIndex = null;
  let opens = {};

  function toggle(i) {
    if ($isMobile) {
      activeIndex = activeIndex === i ? null : i;
    } else {
      opens = { ...opens, [i]: !opens[i] };
    }
  }

  // Inicializamos las variables pricesTableHeaders y pricesTable1Rows, como variables reactivas, para que se actualicen cada vez que cambie el país seleccionado.
  $: pricesTableHeaders = [
    $_('prices.explanation.table_1.1_1'),
    $_('prices.explanation.table_1.1_2'),
    $_('prices.explanation.table_1.1_3'),
  ];

  $: pricesTable1Rows = [
    [$_('prices.explanation.table_1.2_1'), $_('prices.explanation.table_1.2_2'), $_('prices.explanation.table_1.2_3')],
    [$_('prices.explanation.table_1.3_1'), $_('prices.explanation.table_1.3_2'), $_('prices.explanation.table_1.3_3')],
    [$_('prices.explanation.table_1.4_1'), $_('prices.explanation.table_1.4_2'), $_('prices.explanation.table_1.4_3')],
  ];

  $: pricesTable2Rows = [
    [$_('prices.explanation.table_2.2_1'), $_('prices.explanation.table_2.2_2'), $_('prices.explanation.table_2.2_3')],
    [$_('prices.explanation.table_2.3_1'), $_('prices.explanation.table_2.3_2'), $_('prices.explanation.table_2.3_3')],
    [$_('prices.explanation.table_2.4_1'), $_('prices.explanation.table_2.4_2'), $_('prices.explanation.table_2.4_3')],
  ];

  $: pricesTable3Rows = [
    [$_('prices.explanation.table_3.2_1'), $_('prices.explanation.table_3.2_2'), $_('prices.explanation.table_3.2_3')],
    [$_('prices.explanation.table_3.3_1'), $_('prices.explanation.table_3.3_2'), $_('prices.explanation.table_3.3_3')],
    [$_('prices.explanation.table_3.4_1'), $_('prices.explanation.table_3.4_2'), $_('prices.explanation.table_3.4_3')],
  ];

  $: pricesTable4Rows = [
    [$_('prices.explanation.table_4.2_1'), $_('prices.explanation.table_4.2_2'), $_('prices.explanation.table_4.2_3')],
    [$_('prices.explanation.table_4.3_1'), $_('prices.explanation.table_4.3_2'), $_('prices.explanation.table_4.3_3')],
    [$_('prices.explanation.table_4.4_1'), $_('prices.explanation.table_4.4_2'), $_('prices.explanation.table_4.4_3')],
  ];

</script>

<div class="explanation-container">
  <Accordion title={$_("explanation.title_1")} open={$isMobile ? activeIndex === 0 : !!opens[0]} onToggle={() => toggle(0)}>
    <div class="explanation-item">
      <p>{$_("prices.explanation.paragraph_1")}</p>
      <ol>
        <li>{$_("prices.explanation.item_1")}</li>
        <li>{$_("prices.explanation.item_2")}</li>
      </ol>
      <p>
        {$_("prices.explanation.item_explanation_1")}
        <strong>{$_("common.calculate_bold")}</strong>{$_("prices.explanation.item_explanation_2")}
      </p>

      <!-- Formula -->
      <div class="formula">
        <span class="left">{$_("prices.explanation.form_left_part")}</span>
        <span class="left">{$_("prices.explanation.form_left_part_2")}</span>
        <span class="frac">
          <span class="top">{$_("prices.explanation.form_top_part")}</span>
          <span class="bottom">{$_("prices.explanation.form_down_part")}</span>
        </span>
      </div>
  </Accordion>
  <Accordion title={$_("explanation.title_2")} open={$isMobile ? activeIndex === 1 : !!opens[1]} onToggle={() => toggle(1)}>
    <div class="explanation-item">
      <ul class="punteo-list">
        <li>
          {$_("explanation.important_concepts_common_2")}
          {$_("prices.explanation.item_1_concepts_1")}
          <strong>{$_("prices.explanation.item_1_concepts_bold")}</strong>
          {$_("prices.explanation.item_1_concepts_2")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          {$_("prices.explanation.item_2_concepts_1")}
          <strong>{$_("prices.explanation.item_2_concepts_bold")}</strong>
          {$_("prices.explanation.item_2_concepts_2")}
        </li>
        <li>
          {$_("prices.explanation.item_3_concepts_1")}
          <strong>{$_("prices.explanation.item_3_concepts_bold")}</strong>{$_("prices.explanation.item_3_concepts_2")}
        </li>
      </ul>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_3")} open={$isMobile ? activeIndex === 2 : !!opens[2]} onToggle={() => toggle(2)}>
    <div class="explanation-item">
      <p>{$_("prices.explanation.paragraph_2")}</p>
      <ul class="punteo-list">
        <li>{$_("prices.explanation.item_1_factors")}</li>
        <li>{$_("prices.explanation.item_2_factors")}</li>
        <li>{$_("prices.explanation.item_3_factors")}</li>
        <li>{$_("prices.explanation.item_4_factors")}</li>
        <li>{$_("prices.explanation.item_5_factors")}</li>
        <li>{$_("prices.explanation.item_6_factors")}</li>
        <li>{$_("prices.explanation.item_7_factors")}</li>
      </ul>
      <p>{$_("prices.explanation.paragraph_3")}</p>
      <p>
        {$_("prices.explanation.paragraph_4_1")}{$_("profit.calculation.title")}{$_("prices.explanation.paragraph_4_2")}
      </p>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_4")} open={$isMobile ? activeIndex === 3 : !!opens[3]} onToggle={() => toggle(3)}>
    <div class="explanation-item">
      <p>
        {$_("prices.explanation.paragraph_5_1")}
        <strong>{$_("prices.explanation.paragraph_5_bold")}</strong>{$_("prices.explanation.paragraph_5_2")}
      </p>
      <DataTable headers={pricesTableHeaders} rows={pricesTable1Rows}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_5")} open={$isMobile ? activeIndex === 4 : !!opens[4]} onToggle={() => toggle(4)}>
    <div class="explanation-item">
      <p>
        {$_("prices.explanation.paragraph_5_1")}
        <strong>{$_("prices.explanation.paragraph_5_bold")}</strong>{$_("prices.explanation.paragraph_6")}
      </p>
      <DataTable headers={pricesTableHeaders} rows={pricesTable2Rows}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_6")} open={$isMobile ? activeIndex === 5 : !!opens[5]} onToggle={() => toggle(5)}>
    <div class="explanation-item">
      <p>
        {$_("prices.explanation.paragraph_5_1")}
        <strong>{$_("prices.explanation.paragraph_5_bold")}</strong>{$_("prices.explanation.paragraph_6")}
      </p>
      <DataTable headers={pricesTableHeaders} rows={pricesTable3Rows}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_7")} open={$isMobile ? activeIndex === 6 : !!opens[6]} onToggle={() => toggle(6)}>
    <div class="explanation-item">
      <p>
        {$_("prices.explanation.paragraph_5_1")}
        <strong>{$_("prices.explanation.paragraph_5_bold")}</strong>{$_("prices.explanation.paragraph_6")}
      </p>
      <DataTable headers={pricesTableHeaders} rows={pricesTable4Rows}/>
    </div>
  </Accordion>
</div>
